import {
  allowancesFilter,
  allowancesFilterSelection,
  classTypeFilter,
  classTypeFilterSelection,
  defaultAllowancesDataReceiver,
  defaultOrgTypesDataReceiver,
  orgsFilter,
  orgsFilterSelection,
  orgTypesFilter,
  orgTypesFilterSelection,
  parallelsFilter,
  parallelsFilterSelection,
  periodFilter,
  schoolYearFilter,
  schoolYearFilterSelection,
  studentListFilter,
  studentListFilterSelection,
  classesListFilter,
  classesListFilterSelection,
  detailsGroupFilter,
  detailsGroupFilterSelection,
  educationLevelsFilter,
  educationLevelsFilterSelection,
  employeeListFilter,
  employeeListFilterSelection,
  subsidyTypeFilterSelection,
  subsidiesSumsAndKitsFilter,
  subsidiesSumsAndKitsFilterSelection,
  viewTypeFilterSelection,
} from 'app/dataProviders/filter-items'
import { detailsFilter } from 'app/common/ui-next/_filter-compilations/details'

import { DetailedSubsidyClassType } from './filterItems/types'

const detailedClassTypeData = () => [
  { id: DetailedSubsidyClassType.Common, title: 'Класс' },
  { id: DetailedSubsidyClassType.DayCares, title: 'Группа продленного дня' },
  { id: DetailedSubsidyClassType.Camp, title: 'Лагерь' },
]

export const filterInit = () => {
  orgTypesFilter.addDataReceiver(defaultOrgTypesDataReceiver)
  orgTypesFilter.dataReceive()
  allowancesFilter.addDataReceiver(defaultAllowancesDataReceiver)
  allowancesFilter.dataReceive()
  classTypeFilter.updateData(detailedClassTypeData)
  classTypeFilter.setStatusReady()

  return () => {
    detailsFilter.resetToDefault()
    orgTypesFilterSelection.reset()
    orgsFilterSelection.reset()
    classTypeFilterSelection.reset()
    schoolYearFilterSelection.reset()
    classesListFilterSelection.reset()
    studentListFilterSelection.reset()
    employeeListFilterSelection.reset()
    allowancesFilterSelection.reset()
    parallelsFilterSelection.reset()
    educationLevelsFilterSelection.reset()
    subsidiesSumsAndKitsFilterSelection.reset()
    subsidyTypeFilterSelection.reset()
    viewTypeFilterSelection.reset()
    detailsGroupFilterSelection.reset()

    orgTypesFilter.reset()
    orgsFilter.reset()
    classTypeFilter.reset()
    schoolYearFilter.reset()
    classesListFilter.reset()
    studentListFilter.reset()
    employeeListFilter.reset()
    parallelsFilter.reset()
    allowancesFilter.reset()
    educationLevelsFilter.reset()
    subsidiesSumsAndKitsFilter.reset()
    detailsGroupFilter.reset()
    periodFilter.reset()
  }
}

export const resetToDefaultAll = () => {
  orgTypesFilterSelection.resetToDefault()
  orgsFilterSelection.resetToDefault()
  classTypeFilterSelection.resetToDefault()
  schoolYearFilterSelection.resetToDefault()
  classesListFilterSelection.resetToDefault()
  studentListFilterSelection.resetToDefault()
  employeeListFilterSelection.resetToDefault()
  allowancesFilterSelection.resetToDefault()
  parallelsFilterSelection.resetToDefault()
  detailsFilter.resetToDefault()
  periodFilter.resetToDefault()
  educationLevelsFilterSelection.resetToDefault()
  subsidiesSumsAndKitsFilterSelection.resetToDefault()
  subsidyTypeFilterSelection.resetToDefault()
  viewTypeFilterSelection.resetToDefault()
  detailsGroupFilterSelection.resetToDefault()
}
